import React, { useEffect } from 'react';
import * as MuiMaterial from '@mui/material';
import { Theme } from '@mui/material/styles';
import { FieldProps } from '@rjsf/core';
import { DayTime, DayTimeType } from '../../stories/DayTimeAndRange/DayTime';
const { FormControl, useMediaQuery } = MuiMaterial;
const DayTimeField = ({
  formData,
  idSchema,
  schema,
  onChange,
  disabled,
  readonly,
  formContext: { t, onHasChanged },
}: FieldProps): JSX.Element => {
  const isSmallDevice = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const id = idSchema?.$id;
  const title = schema?.title;
  const [data, setData] = React.useState<Array<DayTimeType>>(formData || []);
  const _onAdd = (value: Array<DayTimeType>) => {
    onChange(value);
    setData(value);
    setTimeout(() => onHasChanged({ id }), 0);
  };
  useEffect(() => {
    setData(formData);
  }, [formData]);
  return (
    <FormControl fullWidth={true} key={`${id}-form-control`}>
      <DayTime
        value={data}
        title={title}
        t={t}
        isSmallDevice={isSmallDevice}
        onAdd={_onAdd}
        disabled={disabled || readonly}
      />
    </FormControl>
  );
};
export default DayTimeField;
